import { useTranslation } from 'next-i18next';
import styles from '@components/InspirationProgressLine/InspirationProgressLine.styles';
import ProgressBar from '@components/Progress/ProgressBar';
import useInflectedTranslation from '@hooks/useInflectedTranslation';
type PropsType = {
  actualCount?: number;
  maxCount: number;
  isInterior: boolean;
};
const InspirationProgressLine = ({
  actualCount = 0,
  maxCount,
  isInterior
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const {
    getInflectedTranslation
  } = useInflectedTranslation();
  return <>
      <ProgressBar actualCount={actualCount} maxCount={maxCount} />
      <div sx={styles.visableCount}>
        {actualCount} {t('of')} {maxCount} {getInflectedTranslation(maxCount, isInterior ? 'interiorDesign' : 'ideas')}
      </div>
    </>;
};
export default InspirationProgressLine;